var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickviewinv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87031 7.22461C1.51459 8.05774 0 9.35351 0 10.808C0 12.8464 2.96402 14.5663 7.05719 15.1488V18.0881L11.0899 14.448L7.05719 10.808V13.2923C3.88145 12.7827 2.01634 11.5633 2.01634 10.808C2.01634 10.362 2.67153 9.74477 3.87031 9.21003V7.22461Z",
    fill: "#5CC7C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2942 9.21051C17.4923 9.74514 18.1471 10.3621 18.1471 10.808C18.1471 11.4723 16.6751 12.5279 14.1144 13.1103V14.9758C17.6732 14.2751 20.1634 12.6735 20.1634 10.808C20.1634 9.35373 18.6493 8.05813 16.2942 7.22499V9.21051Z",
    fill: "#5CC7C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2202 5.83898L14.966 3.16949M10.2202 5.83898V11.178M10.2202 5.83898L5.47449 3.16949M10.2202 0.5L14.966 3.16949V8.50847L10.2202 11.178L5.47449 8.50847V3.16949L10.2202 0.5Z",
    stroke: "#5CC7C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickviewinv);
export default __webpack_public_path__ + "static/media/quickviewinv.807b523b884b474370c4b092349d9073.svg";
export { ForwardRef as ReactComponent };